import { render, staticRenderFns } from "./TheLayoutDrawerList.vue?vue&type=template&id=0af3271f&"
import script from "./TheLayoutDrawerList.vue?vue&type=script&lang=js&"
export * from "./TheLayoutDrawerList.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutDrawerList.vue?vue&type=style&index=0&id=0af3271f&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af3271f')) {
      api.createRecord('0af3271f', component.options)
    } else {
      api.reload('0af3271f', component.options)
    }
    module.hot.accept("./TheLayoutDrawerList.vue?vue&type=template&id=0af3271f&", function () {
      api.rerender('0af3271f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/TheLayoutDrawerList.vue"
export default component.exports